import React, { useState } from "react";
import { compose } from "redux";

import withTranslations from "../../../../../hocs/withTranslations";
import { STOCK_AI_ANALYSIS_DISCLAIMER_KEY } from "../../../../../lib/stockAiAnalysis/constants";

const AiAnalysisDisclaimer = ({ translate }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="bg-gray-5 py-3 px-4 rounded-1 text-black mb-4 text-xs">
      <span>
        {translate(STOCK_AI_ANALYSIS_DISCLAIMER_KEY.SHORT)}{" "}
        {expanded ? null : (
          <button
            type="button"
            className="underline text-black inline border-none bg-unset p-0 cursor-pointer text-left"
            onClick={() => setExpanded(true)}
            aria-expanded="false"
          >
            {translate(STOCK_AI_ANALYSIS_DISCLAIMER_KEY.SHOW_MORE)}
          </button>
        )}
      </span>
      {expanded ? (
        <div
          dangerouslySetInnerHTML={{
            __html: translate(STOCK_AI_ANALYSIS_DISCLAIMER_KEY.MORE)
          }}
        />
      ) : null}
      {expanded ? (
        <button
          type="button"
          className="underline text-black block border-none bg-unset p-0 cursor-pointer text-left mt-2"
          onClick={() => setExpanded(false)}
          aria-expanded="true"
        >
          {translate(STOCK_AI_ANALYSIS_DISCLAIMER_KEY.SHOW_LESS)}
        </button>
      ) : null}
    </div>
  );
};

export default compose(withTranslations)(AiAnalysisDisclaimer);
